import {
    GET_DATA_MASTER_MENU,
    GET_ADD_MASTER_MENU,
    GET_EDIT_MASTER_MENU,
    GET_DELETE_MASTER_MENU,
    SUCCESS_MESSAGE_MENU,
    ERROR_MESSAGE_MENU,
    HIDE_MESSAGE_MENU,
} from 'constants/ActionTypes';


let INIT_STATE = {
    alertMessageMenu: '',
    successMessageMenu: false,
    errorMessageMenu: false,
    dataMasterMenu: [],
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_DATA_MASTER_MENU: {
            return {
                ...state,
                dataMasterMenu: action.payload
            }
        }
        case GET_ADD_MASTER_MENU: {
            return {
                ...state,
                dataMasterMenu: [action.payload, ...state.dataMasterMenu]
            }
        }
        case GET_EDIT_MASTER_MENU: {
            return {
                ...state,
                dataMasterMenu: action.payload
            }
        }
        case GET_DELETE_MASTER_MENU: {
            return {
                ...state,
                dataMasterMenu: action.payload
            }
        }
        case SUCCESS_MESSAGE_MENU: {
            return {
                ...state,
                alertMessageMenu: action.payload,
                successMessageMenu: true,
            }
        }
        case ERROR_MESSAGE_MENU: {
            return {
                ...state,
                alertMessageMenu: action.payload,
                errorMessageMenu: true,
            }
        }
        case HIDE_MESSAGE_MENU: {
            return {
                ...state,
                alertMessageMenu: '',
                errorMessageMenu: false,
                successMessageMenu: false,
            }
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./reducers/Menu.js